import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import { SettlementDummyRepository, SettlementHttpRepository } from './infrastructure/repository';

// Application
import { SearchSettlementsQuery } from './application/queries';

// Domain
import { SettlementRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupSettlement(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_ALLIANZ_SETTLEMENT_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<SettlementRepository>(TYPES.CATALOG_ALLIANZ_SETTLEMENT_REPOSITORY)
    .to(
      withDummies
        ? SettlementDummyRepository
        : SettlementHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchSettlementsQuery>(TYPES.SEARCH_CATALOG_ALLIANZ_SETTLEMENT_QUERY)
    .to(SearchSettlementsQuery)
    .inSingletonScope();
}
